import {mapToFlatListWithKey, traverseWithKey} from '@hconnect/common/utils'
import {orderBy} from 'lodash'

import {
  LocationStats,
  PlantLocationStats,
  LocationTreeTableEntry,
  PlantTableEntry,
  LocationType
} from '../types'

const traverseStats = (statsList: LocationStats[], op: (stats: LocationStats) => void) =>
  traverseWithKey('subLocations', statsList, op)

export const mapToDashboardEntries = (stats: LocationStats[]): LocationTreeTableEntry[] => {
  return stats.map(
    (
      {id, type, name, countryCode, difficultySummaries, responsible, lastUpdate, subLocations},
      index
    ) => ({
      id,
      type,
      ...(type === LocationType.Plant && {
        plantCode: (stats[index] as PlantLocationStats).plantCode
      }),
      name,
      countryCode,
      responsible: responsible?.name ?? '',
      lastUpdate,
      difficultySummaries,
      subItems: mapToDashboardEntries(subLocations)
    })
  )
}

export const extractPlantLocations = (statsList: LocationStats[]): PlantTableEntry[] => {
  const result: PlantTableEntry[] = []

  const plantCountryMap: Record<string, string> = {}

  traverseStats(statsList, (stats: LocationStats) => {
    const {
      id,
      name,
      type,
      countryCode,
      subLocations,
      difficultySummaries,
      responsible,
      lastUpdate
    } = stats
    if (type === LocationType.Country && countryCode) {
      subLocations.forEach((location) => {
        const plant = location as PlantLocationStats
        plantCountryMap[plant.id] = countryCode
      })
    } else if (type === LocationType.Plant) {
      result.push({
        id,
        plantCode: (stats as PlantLocationStats).plantCode,
        name,
        countryCode: plantCountryMap[id],
        difficultySummaries,
        responsible: responsible?.name ?? '',
        lastUpdate
      })
    }
  })

  return orderBy(result, ['name'], ['asc'])
}

type PlantOverviewData = {
  showPlantOverview: boolean
  redirectPlantId?: string
}

export const getPlantRedirectData = (data?: LocationStats[]): PlantOverviewData => {
  if (!data) return {showPlantOverview: true}
  const plantList = mapToFlatListWithKey('subLocations', data || []).filter(
    (item) => item.type === LocationType.Plant
  )
  const showPlantOverview = plantList.length > 1
  const result: PlantOverviewData = {showPlantOverview}

  if (!showPlantOverview) {
    result.redirectPlantId = plantList[0]?.id
  }

  return result
}
